import React, { useState, useEffect, useContext } from "react";
import { Modal, Tab, Nav, Button, Form } from "react-bootstrap";
import axios from "axios";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import { useNavigate } from "react-router-dom";
import FeeModal from "../Convert/FeeModal";
import InfoPopUp from "../../Common/InfoPopUp";
import ModalContent from "../../Common/Modal";
import { DataContext } from ".";
import { useSelector } from "react-redux";
import ActionButton from "../../Common/ActionButton";
import { Box } from "@mui/material";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";
import InfoIcon from "@mui/icons-material/Info";

const title = "My Trades";
const description = "Trade History shows all successful BUY and SELL trades";

const BottomTable = () => {
  const {
    isPublicView,
    currencycode,
    basecurrency,
    refresh,
    setUpdateBalance,
    updateBalance,
    setUpdateOrder,
  } = useContext(DataContext);
  const { btncolor } = useSelector((state) => state);
  const theme = localStorage.getItem("theme");
  const navigate = useNavigate();
  const [activeButton, setActiveButton] = useState("ALL");
  const [activeTab, setActivetab] = useState("hist");
  const [show, setShow] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showDeleteOpen, setShowDeleteOpen] = useState(false);
  const [showModify, setShowModify] = useState(false);
  const [showModifyStop, setShowModifyStop] = useState(false);

  const userId = localStorage.getItem("userId");
  const accessToken = localStorage.getItem("access_token");

  const [myTradeTableAllPairs, setMyTradeTableAllPairs] = useState(false); // Assuming this state is coming from somewhere
  const [loader, setLoader] = useState(true);
  const [spotMyTradeData, setSpotMyTradeData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [tradeHistory, setTradeHistory] = useState([]);
  const [noData, setNoData] = useState(true);
  const [myTradeTableDisplayStatus, setMyTradeTableDisplayStatus] = useState(0);
  const [spotMyOfferData, setSpotMyOfferData] = useState([]);

  const [selectedBuyingAssetText, setSelectedBuyingAssetText] = useState("BTC"); // Example value, replace with your actual state value
  const [selectedSellingAssetText, setSelectedSellingAssetText] =
    useState("INR");
  const [tradeOfferById, setTradeOfferById] = useState([]);

  const [filterMyOfferStatus, setFilterMyOfferStatus] = useState("ALL");
  const [tradeOfferByIdBuy, setTradeOfferByIdBuy] = useState([]);
  const [tradeOfferByIdSell, setTradeOfferByIdSell] = useState([]);

  const [myOfferTableAllPairs, setMyOfferTableAllPairs] = useState(false);
  const [tradeOfferByIdNewData, setTradeOfferByIdNewData] = useState([]);

  const [buySellDivStatus, setBuySellDivStatus] = useState("");

  const [buyDataNew, setBuyDataNew] = useState([]);
  const [myStopLimitAllPairs, setMyStopLimitAllPairs] = useState(false);

  const [offerData, setOfferData] = useState(null);
  const [modifyAmount, setModifyAmount] = useState("");
  const [modifyPrice, setModifyPrice] = useState("");
  const [modifyVolume, setModifyVolume] = useState("");
  const [modifyType, setModifyType] = useState("");
  const [tabModifyAmount, setTabModifyAmount] = useState("");
  const [tabModifyPrice, setTabModifyPrice] = useState("");
  const [tabModifyVolume, setTabModifyVolume] = useState("");
  const [tabModifyMarginType, setTabModifyMarginType] = useState("");
  const [manageOfferId, setManageOfferId] = useState(null);
  const [backupData, setBackupData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [delOfferId, setDelOfferId] = useState(null);
  const [delTxnType, setDelTxnType] = useState(null);
  const [delOfferType, setDelOfferType] = useState(null);
  const [delPrice, setDelPrice] = useState(null);
  const [delbal, setDelbal] = useState(null);
  const [modalContent, setModalContent] = useState(null);
  const [buyData, setBuyData] = useState([]);
  const [sellData, setSellData] = useState([]);

  const [tabKey, setTabKey] = useState("amountUpdate");
  const tradep = 6;
  const tradem = 6;

  const [modifySlAmount, setModifySlAmount] = useState(0);
  const [modifySlPrice, setModifySlPrice] = useState(0);
  const [modifySlTrigger, setModifySlTrigger] = useState(0);
  const [modifySlOffer, setModifySlOffer] = useState(null);
  const [flag, setFlag] = useState(null);
  const [tradePrice, setTradePrice] = useState(0);
  const [isStopLimitModifyEnable, setIsStopLimitModifyEnable] = useState(false);
  const [marginstoplimitprice, setMarginStopLimitPrice] = useState(0);
  const [marginTriggerPrice, setMarginTriggerPrice] = useState(0);
  const [marginSellstoplimitprice, setMarginSellStopLimitPrice] = useState(0);
  const [marginSellTriggerPrice, setMarginSellTriggerPrice] = useState(0);
  const [modalShow, setModalShow] = useState(false);
  const [balance, setBalances] = useState();
  const storedAmount = localStorage.getItem("amountprc");

  const amountprc =
    storedAmount !== null &&
    storedAmount !== "null" &&
    storedAmount !== undefined
      ? storedAmount
      : 6;
  const [showFeesInfo, setShowFeesInfo] = useState(false);
  const [exchangeFees, setExchangeFees] = useState(null);
  const [userExchangeFee, setUserExchangeFee] = useState({
    totalVolume: 0,
    totalFees: 0,
    totalIntAccrued: 0,
    totalIntEarned: 0,
  });

  const handleClose = () => setShow(false);
  const handleCloseDelete = () => setShowDelete(false);
  const handleCloseDeleteOpen = () => setShowDeleteOpen(false);
  const handleCloseModify = () => setShowModify(false);
  const handleCloseModifyStop = () => setShowModifyStop(false);
  const handleCloseFeesInfo = () => setShowFeesInfo(false);

  const handleButtonClick = (button) => {
    setActiveButton(button);
    handleAllButtonClickForMyTrades();
    handleTradeDisplay(button);
  };

  const modalContentMap = {
    hist: {
      title: "TRADE HISTORY",
      description: "Trade History shows all successful BUY and SELL trades.",
    },
    open: {
      title: "OPEN ORDERS",
      description:
        "Open Orders shows all BUY and SELL Offers waiting to be executed.",
    },
    stop: {
      title: "STOP-LIMIT",
      description:
        "Stop Orders shows all BUY and SELL offers created using STOP LIMIT",
    },
  };

  const currentContent = modalContentMap[activeTab];

  useEffect(() => {
    if (isPublicView) return;
    setActivetab(localStorage.getItem("tradeNavHist") || "hist");
    renderDataForMyTradeSpot();
    renderDataForMyOfferSpot();
    callAllStopLimitOffers();
  }, [refresh]);
  useEffect(() => {
    if (isPublicView) return;
    getFeesData();
  }, []);

  const renderDataForMyTradeSpot = () => {
    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");

    axios
      .get(
        `https://stream.paybito.com/StreamingApi/rest/getTradeHistoryByIdRest?uuid=${uuid}&buyingAssetCode=${currencycode}&sellingAssetCode=${basecurrency}&pageNo=1&noOfItemsPerPage=10`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      )
      .then((response) => {
        setLoader(false);
        setSpotMyTradeData(response.data.tradeListResult);
        document.body.classList.remove("overlay");
      })
      .catch((error) => {
        setLoader(false);
        document.body.classList.remove("overlay");
        if (error.response && error.response.data.error === "invalid_token") {
          //logout
        } else {
          showToast("error", "Could Not Connect To Server");
        }
      });
  };

  const getFeesData = async () => {
    try {
      const accessToken = localStorage.getItem("access_token");
      const uuid = localStorage.getItem("uuid");

      const fundingResponse = await axios.get(
        `${WEBSERVICE}fMargin/fundingHomeView`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );

      setExchangeFees(fundingResponse.data.P_FUNDING_CURRENCY);

      const tradingFeesResponse = await axios.get(
        `${WEBSERVICE}fTrade/userWiseTradingFees?uuid=${uuid}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );

      const res = tradingFeesResponse.data;
      if (res.userTradingFees && res.userTradingFees.length > 0) {
        setUserExchangeFee({
          totalVolume: parseFloat(res.userTradingFees[0].totalVolume).toFixed(
            2
          ),
          totalFees: parseFloat(res.userTradingFees[0].totalFees).toFixed(2),
          totalIntAccrued: parseFloat(
            res.userTradingFees[0].totalIntAccrued
          ).toFixed(2),
          totalIntEarned: res.userTradingFees[0].totalIntEarned,
        });
      } else {
        setUserExchangeFee({
          totalVolume: 0,
          totalFees: 0,
          totalIntAccrued: 0,
          totalIntEarned: 0,
        });
      }
    } catch (error) {
      if (error.response?.data?.error === "invalid_token") {
        //logout
      } else {
        showToast("error", "Could Not Connect To Server");
      }
    } finally {
      // document.body.classList.remove("overlay");
    }
  };
  const logout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  // Function to fetch all trade pairs data
  const callMyTradeAllPairsAPI = () => {
    axios
      .get(
        `https://stream.paybito.com/StreamingApi/rest/getTradeByAccountIDAll?userID=${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setTradeHistory(response.data.tradeListResult);
        setSpotMyTradeData(response.data.tradeListResult);
        setNoData(false);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        showToast("error", "Could Not Connect To Server");
      });
  };

  // Function to handle button click
  const handleAllButtonClickForMyTrades = () => {
    if (myTradeTableAllPairs) {
      callMyTradeAllPairsAPI();
    } else {
      renderDataForMyTradeSpot();
    }
  };

  const saveLastTabTradeComp = (id) => {
    localStorage.setItem("tradeNavHist", id);
    setActivetab(id);
  };

  const handleTradeDisplay = (value) => {
    setMyTradeTableDisplayStatus(value);
  };

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    console.log("check checkbox", isChecked);
    setMyTradeTableAllPairs(isChecked);

    if (isChecked) {
      callMyTradeAllPairsAPI();
    } else {
      renderDataForMyTradeSpot();
    }
  };

  const renderDataForMyOfferSpot = async () => {
    try {
      const response = await axios.get(
        `https://stream.paybito.com/StreamingApi/rest/getOfferByAccountIDRest?userID=${userId}&buyingAssetCode=${currencycode.toLowerCase()}&sellingAssetCode=${basecurrency.toLowerCase()}&pageNo=1&noOfItemsPerPage=10`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );

      console.log("resposne--->", response);

      setLoader(false);
      setTradeOfferById(response?.data?.tradeListResult || []);
    } catch (error) {
      console.error(error);
      // You can also handle errors here if needed.
    }
  };

  const filterMyOffer = (text_type) => {
    setFilterMyOfferStatus(text_type);

    if (text_type === "ALL") {
      // Show all data
      setTradeOfferByIdBuy([]);
      setTradeOfferByIdSell([]);
    } else if (text_type === 1) {
      // Show only "Buy" offers
      const filteredBuy = spotMyTradeData.filter((item) => item.txn_type === 1);
      setTradeOfferByIdBuy(filteredBuy);
      setTradeOfferByIdSell([]);
    } else {
      // Show only "Sell" offers
      const filteredSell = spotMyTradeData.filter(
        (item) => item.txn_type === 2
      );
      setTradeOfferByIdBuy([]);
      setTradeOfferByIdSell(filteredSell);
    }
  };

  const checkValueMyOffer = (event) => {
    const isChecked = event.target.checked;
    console.log("check checkbox", isChecked);
    setMyOfferTableAllPairs(isChecked);

    if (isChecked) {
      callMyOfferAllPairsAPI();
    }
  };

  const callMyOfferAllPairsAPI = () => {
    axios
      .get(
        `https://stream.paybito.com/StreamingApi/rest/getOfferByAccountIDAll?userID=${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        const data = response.data;
        setTradeOfferByIdNewData(data?.tradeListResult);
        setTradeOfferById(data?.tradeListResult);
        clickAllButton();
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const clickAllButton = () => {
    // Implement the logic for clickAllButton here
    console.log("Click All Button Triggered");
  };

  const buySellDivChangeStatus = (status) => {
    setBuySellDivStatus(status);
  };

  const handleStopLimitAllButton = (e) => {
    const isChecked = e.target.checked;
    console.log("check checkbox", isChecked);
    setMyStopLimitAllPairs(isChecked);
    if (isChecked) {
      callStopLimitAllPairsAPI();
    } else {
      callAllStopLimitOffers();
    }
  };

  const callStopLimitAllPairsAPI = async () => {
    try {
      const response = await axios.get(
        `https://stream.paybito.com/StreamingApi/rest/getStopLimitByAccountIDAll?userID=${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setBuyDataNew(response.data.tradeListResult);
      console.log(
        response.data.tradeListResult.length,
        typeof response.data.tradeListResult.length
      );

      // Call another function after data is fetched
      //   handleClickAllButton('spotStopLimitAllButton');
    } catch (error) {
      console.error("Error fetching stop limit data", error);
    }
  };

  const callAllStopLimitOffers = async () => {
    // Logic for handling all stop limit offers
    console.log("Handling all stop limit offers");
    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");

    let payload = {
      uuid: uuid,
      buying_asset_code: currencycode,
      selling_asset_code: basecurrency,
      txn_type: 1,
    };
    try {
      const response = await axios.post(
        `${WEBSERVICE}userTrade/GetStopLossBuySell`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${accessToken}`,
          },
        }
      );
      setBuyDataNew(response.data.stopLossList);
    } catch (error) {
      if (error.response?.data?.error === "invalid_token") {
        //logout
      } else {
        showToast("error", "Could Not Connect To Server");
      }
    } finally {
      // document.body.classList.remove("overlay");
    }
  };

  const convertToNumber = (val) => {
    return parseFloat(val).toFixed(
      parseInt(localStorage.getItem("priceprc") || 6)
    );
  };
  const myTradeTotal = (val) => {
    return parseFloat(val).toFixed(
      parseInt(localStorage.getItem("priceprc")) || 6
    );
  };

  const dateFormat = (inputDate) => {
    // Parse the input date string into a Date object
    const date = new Date(inputDate);

    // Function to pad with zero if less than 10
    const padZero = (num) => (num < 10 ? `0${num}` : num);

    // Get the formatted date
    const formattedDate = `${padZero(date.getDate())}-${date
      .toLocaleString("en-GB", { month: "short" })
      .toUpperCase()}-${date.getFullYear()} ${padZero(
      date.getHours() % 12 || 12
    )}:${padZero(date.getMinutes())}:${padZero(date.getSeconds())} ${
      date.getHours() >= 12 ? "PM" : "AM"
    }`;
    return formattedDate;
  };

  const getOfferDetails = (content, offerId) => {
    setLoading(true);
    setOfferData(null);
    setTabModifyAmount(0);
    setTabModifyPrice(0);
    setModifyAmount(0);
    setModifyPrice(0);
    setModifyVolume(0);
    setModifyType("");
    setTabModifyVolume(0);
    setTabModifyMarginType("");

    const inputObj = {
      offer_id: offerId,
      userId: userId,
      uuid: localStorage.getItem("uuid"),
    };

    axios
      .post(`${WEBSERVICE}userTrade/GetOfferByID`, inputObj, {
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${accessToken}`,
        },
      })
      .then((response) => {
        setLoading(false);
        const result = response.data;
        setBackupData(result);

        if (result.error.error_data !== 0) {
          showToast("error", result.error.error_msg); // Handle error alert
        } else {
          setManageOfferId(offerId);
          const tradeResult = result.tradeResult;

          setModifyAmount(parseFloat(tradeResult.amount));
          setTabModifyAmount(parseFloat(tradeResult.amount));
          setModifyPrice(parseFloat(tradeResult.price));
          setTabModifyPrice(parseFloat(tradeResult.price));
          setTabModifyVolume(
            parseFloat(tradeResult.amount) * parseFloat(tradeResult.price)
          );
          setModifyVolume(
            parseFloat(tradeResult.amount) * parseFloat(tradeResult.price)
          );
          setModifyType(tradeResult.txn_type);
          setUpdateBalance(!updateBalance);
          setUpdateOrder((prev) => !prev);
          setShowModify(true); // Open modal
        }
      })
      .catch((error) => {
        setLoading(false);
        if (error.response && error.response.data.error === "invalid_token") {
          // Handle session timeout
          // Handle logout logic here
          //logout
        } else {
          showToast("error", "Could Not Connect To Server"); // Handle server error
        }
      });
  };

  const getMarginOfferDetails = (content, offerId) => {
    setLoading(true);
    setOfferData(null);
    setTabModifyAmount(0);
    setTabModifyPrice(0);
    setModifyAmount(0);
    setModifyPrice(0);
    setModifyVolume(0);
    setModifyType("");
    setTabModifyVolume(0);
    setTabModifyMarginType("");

    const inputObj = {
      offer_id: offerId,
      userId: userId,
      uuid: localStorage.getItem("uuid"),
    };

    console.log("calling");

    axios
      .post(`${WEBSERVICE}userTrade/GetOfferByID`, inputObj, {
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${accessToken}`,
        },
      })
      .then((response) => {
        setLoading(false);
        const result = response.data;
        setBackupData(result);

        if (result.error.error_data !== 0) {
          showToast("error", result.error.error_msg); // Handle error alert
        } else {
          // showToast("success", "Offer amount update successfull");
          setManageOfferId(offerId);
          const tradeResult = result.tradeResult;

          setModifyAmount(parseFloat(tradeResult.amount));
          setTabModifyAmount(parseFloat(tradeResult.amount));
          setModifyPrice(parseFloat(tradeResult.price));
          setTabModifyPrice(parseFloat(tradeResult.price));
          setTabModifyVolume(
            parseFloat(tradeResult.amount) * parseFloat(tradeResult.price)
          );
          setModifyVolume(
            parseFloat(tradeResult.amount) * parseFloat(tradeResult.price)
          );
          setModifyType(tradeResult.txn_type);
          setUpdateBalance(!updateBalance);
          setUpdateOrder((prev) => !prev);

          if (tradeResult?.offerType === "3") {
            setTabModifyMarginType("1");
          } else if (tradeResult?.offerType === "4") {
            setTabModifyMarginType("2");
          }
          setShowModify(true); // Open modal
        }
      })
      .catch((error) => {
        setLoading(false);
        if (error.response && error.response.data.error === "invalid_token") {
          // Handle session timeout
          // Handle logout logic here
          //logout
        } else {
          showToast("error", "Could Not Connect To Server"); // Handle server error
        }
      });
  };

  const deleteTrade = (content, offerId, txnType, price, amount, offerType) => {
    setDelOfferId(offerId);
    setDelTxnType(txnType);
    setDelOfferType(offerType);
    setDelPrice(price);
    setDelbal(amount);
    setModalContent(content);
    setShowDeleteOpen(true); // Show the modal
  };

  const marginDeleteTrade = (
    content,
    offerId,
    txnType,
    price,
    amount,
    offerType
  ) => {
    setDelOfferId(offerId);
    setDelTxnType(txnType);
    setDelOfferType(offerType);
    setDelPrice(price);
    setDelbal(amount);
    setModalContent(content);
    setShowDeleteOpen(true); // Show the modal
  };

  const manageOfferAmount = async () => {
    //  showToast("Loading...", "dark");

    console.log("Amount update");

    try {
      let inputObj = {
        offer_id: manageOfferId,
        amount: tabModifyAmount,
        price: tabModifyPrice,
        txn_type: modifyType,
        action: "amountupdate",
        uuid: localStorage.getItem("uuid"),
      };

      if (modifyType === 1) {
        inputObj["selling_asset_code"] = basecurrency?.toUpperCase();
        inputObj["buying_asset_code"] = currencycode?.toUpperCase();
      } else {
        inputObj["buying_asset_code"] = basecurrency?.toUpperCase();
        inputObj["selling_asset_code"] = currencycode?.toUpperCase();
      }

      const jsonString = JSON.stringify(inputObj);

      const response = await axios.post(
        `${WEBSERVICE}userTrade/TradeManageOffer`,
        jsonString,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + accessToken,
          },
        }
      );

      if (response.data.error.error_data !== 0) {
        showToast("error", response.data.error.error_msg);
      } else {
        // showToast("success", response.data.error.error_msg);
        showToast("success", "Offer amount update successfull");
        setShowModify(false);
        setUpdateBalance(!updateBalance);
        setUpdateOrder((prev) => !prev);

        if (localStorage.getItem("tradeNavHist") === "open") {
          renderDataForMyOfferSpot();
        } else if (localStorage.getItem("tradeNavHist") === "stop") {
          renderDataForStopLimitSpot("buy");
        } else {
          renderDataForMyTradeSpot();
        }
      }
    } catch (error) {
      if (error.response && error.response.data.error === "invalid_token") {
        //logout
      } else {
        showToast("error", "Could Not Connect To Server");
      }
    }
  };

  const renderDataForStopLimitSpot = async (param) => {
    let transactionType = param === "buy" ? "1" : "2";
    let uuid = localStorage.getItem("uuid");
    let buyingAsset =
      param === "buy"
        ? currencycode?.toUpperCase()
        : basecurrency?.toUpperCase();
    let sellingAsset =
      param === "buy"
        ? basecurrency?.toUpperCase()
        : currencycode?.toUpperCase();

    let payload = {
      uuid,
      buying_asset_code: buyingAsset,
      selling_asset_code: sellingAsset,
      txn_type: transactionType,
    };

    try {
      setLoader(true);
      const response = await axios.post(
        `${WEBSERVICE}userTrade/GetStopLossBuySell`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + accessToken,
          },
        }
      );

      if (param === "buy") {
        setBuyData(response.data.stopLossList);
      } else {
        setSellData(response.data.stopLossList);
      }
    } catch (error) {
      if (error.response?.data?.error === "invalid_token") {
        //logout
      } else {
        showToast("error", "Could Not Connect To Server");
      }
    } finally {
      setLoader(false);
      document.body.classList.remove("overlay");
    }
  };

  const manageOfferPrice = async () => {
    try {
      // showToast("Loading...", "dark");
      const uuid = localStorage.getItem("uuid");

      let inputObj = {
        offer_id: manageOfferId,
        selling_asset_code:
          modifyType === 1
            ? basecurrency?.toUpperCase()
            : currencycode?.toUpperCase(),
        buying_asset_code:
          modifyType === 1
            ? currencycode?.toUpperCase()
            : basecurrency?.toUpperCase(),
        amount: modifyAmount,
        price: tabModifyPrice,
        txn_type: modifyType,
        uuid,
      };

      const tradeManageOfferResponse = await axios.post(
        `${WEBSERVICE}userTrade/TradeManageOffer`,
        inputObj,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${accessToken}`,
          },
        }
      );

      const result = tradeManageOfferResponse.data;
      // data.loader = false;

      if (result.error.error_data !== 0) {
        showToast("error", result.error.error_msg);
      } else {
        showToast("success", result.error.error_msg);
        setShowModify(false);
        setUpdateBalance(!updateBalance);
        setUpdateOrder((prev) => !prev);
        const tradeNavHist = localStorage.getItem("tradeNavHist");
        if (tradeNavHist === "open") {
          renderDataForMyOfferSpot();
        } else if (tradeNavHist === "stop") {
          renderDataForStopLimitSpot("buy");
        } else {
          renderDataForMyTradeSpot();
        }
      }
    } catch (error) {
      if (error.response && error.response.data.error === "invalid_token") {
        //logout
      }
    }
  };

  const getStoplossPrice = (s) => parseFloat(s.stopLossPrice).toFixed(tradep);
  const getStoplossTriggerPrice = (s) =>
    parseFloat(s.triggerPrice).toFixed(tradep);
  const getStoplossAmount = (s) => parseFloat(s.quantity).toFixed(amountprc);

  const getStoplossPriceNew = (s) =>
    parseFloat(s.stop_loss_price).toFixed(tradep);
  const getStoplossTriggerPriceNew = (s) =>
    parseFloat(s.trigger_price).toFixed(tradep);

  const modifyStoploss = (id, q, p, t, flag) => {
    console.log("calling right", id, q, p, t, flag);
    setModifySlAmount(q);
    setModifySlPrice(p);
    setModifySlTrigger(t);
    setModifySlOffer(id);
    setFlag(flag);
    setShowModifyStop(true);
    setModalShow(true);
  };

  const marginModifyStoploss = (id, q, p, t, tradeprice, flag, type) => {
    console.log("calling left", id, q, p, t, tradeprice, flag, type);

    setIsStopLimitModifyEnable(false);

    setModifySlAmount(q);
    setModifySlPrice(p);
    setModifySlTrigger(t);
    setModifySlOffer(id);
    setTradePrice(tradeprice);
    setFlag(flag ? flag : type);
    setMarginStopLimitPrice(tradeprice * 0.85);
    setMarginTriggerPrice(tradeprice * 0.86);
    setMarginSellStopLimitPrice(tradeprice * 1.15);
    setMarginSellTriggerPrice(tradeprice * 1.14);
    setShowModifyStop(true);
    setModalShow(true);
  };

  const delStoploss = (id, q, p, t, flag, type) => {
    console.log("ididididid", id, q, p, t, flag, type);

    setShowDelete(true);
    setModifySlAmount(q);
    setModifySlPrice(p);
    setModifySlTrigger(t);
    setModifySlOffer(id);
    setFlag(flag ? flag : type);
  };

  const removeStoploss = async () => {
    console.log("flag--->", modifySlOffer, flag);
    const inputObj = {
      modify_type: "delete",
      stoploss_id: Number(modifySlOffer),
      stop_loss_price: modifySlPrice,
      trigger_price: modifySlTrigger,
      quantity: modifySlAmount,
      uuid: localStorage.getItem("uuid"),
      txn_type: flag ? (flag?.toLowerCase() === "buy" ? "1" : "2") : "2",
      selling_asset_code:
        flag?.toLowerCase() === "buy"
          ? basecurrency?.toUpperCase()
          : currencycode?.toUpperCase(),
      buying_asset_code:
        flag?.toLowerCase() === "buy"
          ? currencycode?.toUpperCase()
          : basecurrency?.toUpperCase(),
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}userTrade/ModifyStopLossBuySell`,
        inputObj,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${accessToken}`,
          },
        }
      );

      // data.loader = false;
      if (response.data.error.error_data !== 0) {
        showToast("error", response.data.error.error_msg);
      } else {
        showToast("success", response.data.error.error_msg);
        if (myStopLimitAllPairs) {
          callStopLimitAllPairsAPI();
        } else {
          callAllStopLimitOffers();
        }
        setUpdateBalance(!updateBalance);
        setUpdateOrder((prev) => !prev);
        setShowDelete(false);
      }
    } catch (error) {
      // data.loader = false;
      showToast("error", "Failed to delete stop loss");
    }
  };

  const manageStoploss = async () => {
    // showToast("Loading...");
    // const flag = localStorage.getItem("trade_flag")?.toLowerCase() || "buy";
    const buyingAsset = currencycode?.toUpperCase();
    const sellingAsset = basecurrency?.toUpperCase();
    const tradeServiceUrl = `https://stream.paybito.com/SocketStream/api/marketPrice?symbol=${currencycode}${basecurrency}&side=${
      flag === "buy" ? "BID" : "ASK"
    }&amount=${modifySlAmount}`;

    try {
      const response = await fetch(tradeServiceUrl);
      const result = await response.json();

      if (result.statuscode !== 0) {
        const marketOrderPrice = parseFloat(result.price);
        const isBuy = flag === "buy";

        if (
          (flag === "buy" &&
            marketOrderPrice < modifySlTrigger &&
            marketOrderPrice < modifySlPrice &&
            modifySlTrigger < modifySlPrice) ||
          (flag === "sell" &&
            marketOrderPrice > modifySlTrigger &&
            marketOrderPrice > modifySlPrice &&
            modifySlTrigger > modifySlPrice)
        ) {
          const inputObj = {
            selling_asset_code: flag === "buy" ? sellingAsset : buyingAsset,
            buying_asset_code: flag === "buy" ? buyingAsset : sellingAsset,
            modify_type: "edit",
            stoploss_id: modifySlOffer,
            stop_loss_price: modifySlPrice,
            trigger_price: modifySlTrigger,
            quantity: modifySlAmount,
            txn_type: flag === "buy" ? "1" : "2",
            uuid: localStorage.getItem("uuid"),
          };

          const response = await axios.post(
            `${WEBSERVICE}userTrade/ModifyStopLossBuySell`,
            inputObj,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `BEARER ${accessToken}`,
              },
            }
          );

          if (response.data.error.error_data !== 0) {
            showToast("error", response.data.error.error_msg);
          } else {
            showToast("success", response.data.error.error_msg);
            if (myStopLimitAllPairs) {
              callStopLimitAllPairsAPI();
            } else {
              callAllStopLimitOffers();
            }
            setShowModifyStop(false);
            setUpdateBalance(!updateBalance);
            setUpdateOrder((prev) => !prev);
          }
        } else {
          console.log("isBuy", flag, isBuy);

          setShowModifyStop(false);
          showToast(
            "error",
            isBuy
              ? "*Market order price should be less than stop price and limit price should be greater than stop price"
              : "*Market order price should be greater than stop price and limit price should be less than stop price"
          );
        }
      } else {
        showToast("error", "*Orderbook depth reached, price not found");
      }
    } catch (error) {
      showToast("error", "Error processing request");
    }
  };

  const delMarginOffer = async () => {
    try {
      // setData(prev => ({ ...prev, loader: true }));

      const inputObj = {
        offer_id: delOfferId,
        uuid: localStorage.getItem("uuid"),
        amount: "0",
        txn_type: delTxnType,
        price: delPrice,
        // offerType: "D",
        // marginType: delOfferType,
        // assetCode: localStorage.getItem("assetCode"),
      };

      if (delTxnType === 2) {
        inputObj.selling_asset_code = currencycode?.toUpperCase();
        inputObj.buying_asset_code = basecurrency?.toUpperCase();
      }
      if (delTxnType === 1) {
        inputObj.selling_asset_code = basecurrency?.toUpperCase();
        inputObj.buying_asset_code = currencycode?.toUpperCase();
      }

      const headers = {
        "Content-Type": "application/json",
        authorization: "BEARER " + accessToken,
      };

      const response = await axios.post(
        `${WEBSERVICE}userTrade/TradeManageOffer`,
        inputObj,
        { headers }
      );

      // setData(prev => ({ ...prev, loader: false }));

      if (response.data.error.error_data !== 0) {
        showToast("error", response.data.error.error_msg);
      } else {
        // document.querySelectorAll('.reset').forEach(btn => btn.click());
        showToast("success", response.data.error.error_msg);
        if (myOfferTableAllPairs) {
          callMyOfferAllPairsAPI();
        } else {
          renderDataForMyOfferSpot();
        }
        setUpdateBalance(!updateBalance);
        setUpdateOrder((prev) => !prev);
        setShowDeleteOpen(false);
        getUserTransaction();
        // document.getElementById('trade')?.click();
      }
    } catch (error) {
      // setData(prev => ({ ...prev, loader: false }));

      if (error.response?.data?.error === "invalid_token") {
        //logout
      } else {
        showToast("error", "Could Not Connect To Server");
      }
    }
  };
  const handletabchange = (value) => {
    setTabKey(value);
  };

  const getUserTransaction = async () => {
    setLoader(true);

    let userTransObj = {
      customerId: localStorage.getItem("user_id"),
      uuid: localStorage.getItem("uuid"),
    };

    const selectedMarginType = localStorage.getItem("selectedMarginType");
    if (selectedMarginType) {
      userTransObj.marginType = selectedMarginType;
    }

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getUserBalance`,
        JSON.stringify(userTransObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const result = response.data;
      const balanceList = result.userBalanceList || [];

      if (balanceList.length > 0) {
        localStorage.setItem(
          "usdbalance",
          balanceList.find((item) => item.currencyCode === "USD")
            ?.closingBalance || 0
        );
      }

      if (result.error?.error_data !== 0) {
        showToast("error", "Cannot fetch user balance");
      } else {
        const buyingCrypto = localStorage
          .getItem("buying_crypto_asset")
          ?.toUpperCase();
        const sellingCrypto = localStorage
          .getItem("selling_crypto_asset")
          ?.toUpperCase();
        const pricePrecision = localStorage.getItem("priceprc") || 2;

        let selectedBuyingAssetBalance = null;
        let selectedSellingAssetBalance = null;

        balanceList.forEach((balance) => {
          if (balance.currencyCode === buyingCrypto) {
            selectedBuyingAssetBalance =
              balance.closingBalance.toFixed(pricePrecision);
          }
          if (balance.currencyCode === sellingCrypto) {
            selectedSellingAssetBalance =
              balance.closingBalance.toFixed(pricePrecision);
          }
        });

        setBalances({
          balanceList,
          selectedBuyingAssetBalance,
          selectedSellingAssetBalance,
        });
      }
    } catch (error) {
      if (error.response?.status === 401) {
        //logout
      }
    } finally {
      setLoader(false);
    }
  };

  return (
    <div>
      {/* ── Tab bar ── */}
      <div className="bt-tabbar">
        <div className="bt-tabs">
          <button
            className={`bt-tab ${activeTab === "hist" ? "active-bt" : ""}`}
            style={activeTab === "hist" ? { "--btn-color": btncolor } : {}}
            onClick={() => { handleAllButtonClickForMyTrades(); saveLastTabTradeComp("hist"); }}
          >
            MY TRADES
          </button>
          <button
            className={`bt-tab ${activeTab === "open" ? "active-bt" : ""}`}
            style={activeTab === "open" ? { "--btn-color": btncolor } : {}}
            onClick={() => { renderDataForMyOfferSpot(); saveLastTabTradeComp("open"); }}
          >
            LIMIT ORDERS
          </button>
          <button
            className={`bt-tab ${activeTab === "stop" ? "active-bt" : ""}`}
            style={activeTab === "stop" ? { "--btn-color": btncolor } : {}}
            onClick={() => { callAllStopLimitOffers(); saveLastTabTradeComp("stop"); }}
          >
            STOP-LIMIT ORDERS
          </button>
        </div>
        <button className="bt-fees-btn" style={{ background: btncolor }} onClick={() => setShowFeesInfo(true)}>FEES</button>
      </div>

      {/* ── Filter row ── */}
      <div className="bt-filter-row">
        <div className="bt-filter-left">
          <ActionButton
            options={[{ label: "ALL", value: "ALL" }, { label: "BUY", value: "BUY" }, { label: "SELL", value: "SELL" }]}
            active={activeButton}
            onChange={handleButtonClick}
            btnColor={btncolor}
          />
          <InfoIcon style={{ fontSize: 14, opacity: 0.45, cursor: "pointer" }} onClick={() => setShow(true)} />
        </div>
        <div className="bt-filter-right">
          {activeTab === "hist" && <><input type="checkbox" onClick={handleCheckboxChange} /><label>Show all pairs</label></>}
          {activeTab === "open" && <><input type="checkbox" onClick={checkValueMyOffer} /><label>Show all pairs</label></>}
          {activeTab === "stop" && <><input type="checkbox" onClick={handleStopLimitAllButton} /><label>Show all pairs</label></>}
        </div>
      </div>

      {/* ── MY TRADES ── */}
      {activeTab === "hist" && (
        <div className="bottom_table_modern">
          <table>
            <thead>
              <tr>
                <th>Time stamp</th>
                <th>Asset pair</th>
                <th>Quantity</th>
                <th>Price</th>
                <th>Total Price</th>
                <th>Offer Type</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {spotMyTradeData?.length !== 0 ? (
                spotMyTradeData?.map((row, index) =>
                  (activeButton === "ALL" ? true : !myTradeTableAllPairs ? row?.action === activeButton : row?.type?.toUpperCase() === activeButton) && (
                    <tr key={index}>
                      <td>{dateFormat(row?.transactionTimeStamp)}</td>
                      {row?.action && <td>{row?.action === "BUY" ? `${row?.buying_asset_code}${row?.selling_asset_code}` : `${row?.selling_asset_code}${row?.buying_asset_code}`}</td>}
                      {row?.type && <td>{row?.type === "BUY" ? `${row?.buying_asset_code}${row?.selling_asset_code}` : `${row?.selling_asset_code}${row?.buying_asset_code}`}</td>}
                      {row?.amount && <td>{row?.amount}</td>}
                      {row?.credit_amount && <td>{row?.credit_amount}</td>}
                      <td>{convertToNumber(row?.price)}</td>
                      {row?.amount && <td>{myTradeTotal(row?.amount * row?.price)}</td>}
                      {row?.credit_amount && <td>{myTradeTotal(row?.credit_amount * row?.price)}</td>}
                      <td>{row?.margin_type === null ? "SPOT" : row?.margin_type == 1 ? "ISO" : row?.margin_type == 2 ? "CROSS" : null}</td>
                      {row?.action && <td className={row?.action === "BUY" ? "bt-action-buy" : "bt-action-sell"}>{row.action}</td>}
                      {row?.type && <td className={row?.type === "BUY" ? "bt-action-buy" : "bt-action-sell"}>{row?.type}</td>}
                    </tr>
                  )
                )
              ) : (
                <tr><td colSpan={7} className="bt-no-data">No trades found</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* ── LIMIT ORDERS ── */}
      {activeTab === "open" && (
        <div className="bottom_table_modern">
          <table>
            <thead>
              <tr>
                <th>Time stamp</th>
                <th>Order ID</th>
                <th>Asset pair</th>
                <th>Quantity</th>
                <th>Price</th>
                <th>Total Price</th>
                <th>Action</th>
                <th>Edit</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {tradeOfferById?.length !== 0 ? (
                tradeOfferById?.map((row, index) =>
                  (activeButton === "ALL" ? true : !myOfferTableAllPairs ? row?.action?.toUpperCase() === activeButton : row?.type?.toUpperCase() === activeButton) && (
                    <tr key={index}>
                      <td>{dateFormat(row?.transactionTimeStamp)}</td>
                      <td>{row?.offer_id}</td>
                      <td>{row?.txn_type === 1 ? `${row?.buying_asset_code}${row?.selling_asset_code}` : `${row?.selling_asset_code}${row?.buying_asset_code}`}</td>
                      <td>{row?.amount}</td>
                      <td>{convertToNumber(row?.price)}</td>
                      <td>{myTradeTotal(row?.amount * row?.price)}</td>
                      <td className={row?.txn_type === 1 ? "bt-action-buy" : "bt-action-sell"}>{row?.txn_type === 1 ? "BUY" : "SELL"}</td>
                      <td>
                        <button className="bt-btn" style={{ background: btncolor }} onClick={() => row?.offer_type === 0 ? getOfferDetails("modify", row?.offer_id) : getMarginOfferDetails("modify", row?.offer_id)}>Modify</button>
                      </td>
                      <td>
                        <button className="bt-btn" style={{ background: "#ef4444" }} onClick={() => row?.offer_type === 0 ? deleteTrade("delete", row?.offer_id, row?.txn_type, row?.price, row?.amount, row?.offer_type) : marginDeleteTrade("delete_m", row?.offer_id, row?.txn_type, row?.price, row?.amount, row?.offer_type)}>Delete</button>
                      </td>
                    </tr>
                  )
                )
              ) : (
                <tr><td colSpan={9} className="bt-no-data">No open orders</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* ── STOP-LIMIT ORDERS ── */}
      {activeTab === "stop" && (
        <div className="bottom_table_modern">
          <table>
            <thead>
              <tr>
                <th>Time stamp</th>
                <th>Order ID</th>
                <th>Asset pair</th>
                <th>Quantity</th>
                <th>Limit price</th>
                <th>Stop price</th>
                <th>Action</th>
                <th>Edit</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {buyDataNew?.length !== 0 ? (
                buyDataNew?.map((row, index) =>
                  (activeButton === "ALL" ? true : !myStopLimitAllPairs ? row?.action?.toUpperCase() === activeButton : row?.type?.toUpperCase() === activeButton) && (
                    <tr key={index}>
                      <td>{row?.transactionTimeStamp ? dateFormat(row?.transactionTimeStamp) : dateFormat(row?.timeStamp)}</td>
                      <td>{row?.stopLossId ? row?.stopLossId : row?.offer_id}</td>
                      {row?.buyAssetCode ? (
                        <td>{row?.type === "BUY" ? `${row?.buyAssetCode}${row?.sellAssetCode}` : `${row?.sellAssetCode}${row?.buyAssetCode}`}</td>
                      ) : (
                        <td>{row?.type === "BUY" ? `${row?.buying_asset_code}${row?.selling_asset_code}` : `${row?.selling_asset_code}${row?.buying_asset_code}`}</td>
                      )}
                      <td>{getStoplossAmount(row)}</td>
                      <td>{row?.stopLossPrice ? getStoplossPrice(row) : getStoplossPriceNew(row)}</td>
                      <td>{row?.triggerPrice ? getStoplossTriggerPrice(row) : getStoplossTriggerPriceNew(row)}</td>
                      {row?.action ? (
                        <td className={row?.action?.toUpperCase() === "BUY" ? "bt-action-buy" : "bt-action-sell"}>{row?.action?.toUpperCase()}</td>
                      ) : (
                        <td className={row?.type?.toUpperCase() === "BUY" ? "bt-action-buy" : "bt-action-sell"}>{row?.type?.toUpperCase()}</td>
                      )}
                      <td>
                        <button className="bt-btn" style={{ background: btncolor }} onClick={() => row?.stoplossType == "M" ? marginModifyStoploss(row?.stopLossId ? row?.stopLossId : row?.offer_id, row?.quantity, row?.stopLossPrice ? row?.stopLossPrice : row?.stop_loss_price, row?.triggerPrice ? row?.triggerPrice : row?.trigger_price, row?.tradePrice, row?.action, row?.type) : modifyStoploss(row?.stopLossId ? row?.stopLossId : row?.offer_id, row?.quantity, row?.stopLossPrice ? row?.stopLossPrice : row?.stop_loss_price, row?.triggerPrice ? row?.triggerPrice : row?.trigger_price, row?.action, row?.type)}>Modify</button>
                      </td>
                      <td>
                        {row?.stoplossType !== "M" ? (
                          <button className="bt-btn" style={{ background: "#ef4444" }} onClick={() => delStoploss(row?.stopLossId ? row?.stopLossId : row?.offer_id, row?.quantity, row?.stopLossPrice ? row?.stopLossPrice : row?.stop_loss_price, row?.triggerPrice ? row?.triggerPrice : row?.trigger_price, row?.action, row?.type)}>Delete</button>
                        ) : <span style={{ opacity: 0.4 }}>—</span>}
                      </td>
                    </tr>
                  )
                )
              ) : (
                <tr><td colSpan={9} className="bt-no-data">No stop-limit orders</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      <InfoPopUp
        open={show}
        onClose={handleClose}
        title={currentContent?.title}
        description={currentContent?.description}
      />

      <ModalContent
        open={showModify}
        onClose={handleCloseModify}
        title={`Spot Manage Offer`}
        width="xs"
      >
        <ActionButton
          options={[
            { label: "Amount Update", value: "amountUpdate" },
            { label: "Price Update", value: "priceUpdate" },
          ]}
          active={tabKey}
          onChange={handletabchange}
          btnColor={btncolor}
        />
        {tabKey === "amountUpdate" && (
          <Form>
            <Form.Group>
              <Form.Label>Amount</Form.Label>
              <Form.Control
                type="number"
                className="input-active"
                value={tabModifyAmount}
                onWheel={(e) => e.target.blur()}
                onChange={(e) =>
                  setTabModifyAmount(parseFloat(e.target.value) || 0)
                }
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Price</Form.Label>
              <Form.Control
                type="number"
                className="input-disable"
                value={tabModifyPrice}
                readOnly
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Total Volumn</Form.Label>
              <Form.Control
                type="number"
                className="input-disable"
                value={(tabModifyAmount * tabModifyPrice).toFixed(tradep)}
                readOnly
              />
            </Form.Group>
          </Form>
        )}

        {tabKey === "priceUpdate" && (
          <Form>
            <Form.Group>
              <Form.Label>Amount</Form.Label>
              <Form.Control
                type="number"
                className="input-disable"
                readOnly
                value={tabModifyAmount}
                onChange={(e) => setTabModifyAmount(parseFloat(e.target.value))}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label> Price</Form.Label>
              <Form.Control
                type="number"
                className="input-active"
                value={tabModifyPrice}
                onWheel={(e) => e.target.blur()}
                onChange={(e) => setTabModifyPrice(parseFloat(e.target.value))}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label> Total Volumn</Form.Label>
              <Form.Control
                type="number"
                className="input-disable"
                value={(tabModifyAmount * tabModifyPrice).toFixed(tradep)}
                readOnly
              />
            </Form.Group>
          </Form>
        )}

        <Box className="d-flex justify-content-center align-items-center gap-2 mt-2">
          <OutlinedButton
            variant="outlined"
            className="dark-cancel"
            onClick={handleCloseModify}
          >
            Cancel
          </OutlinedButton>
          {tabKey === "amountUpdate" ? (
            <ContainedButton onClick={manageOfferAmount}>
              Submit
            </ContainedButton>
          ) : (
            <ContainedButton
              // variant="success"
              onClick={manageOfferPrice}
            >
              Submit
            </ContainedButton>
          )}
        </Box>
      </ModalContent>

      <ModalContent
        open={showDeleteOpen}
        onClose={handleCloseDeleteOpen}
        title={`Spot Delete Offer`}
        width="xs"
      >
        <p class="text-center">Are you sure you want to delete this offer?</p>
        <Box className="d-flex justify-content-center align-items-center mt-2 gap-2">
          <OutlinedButton variant="outlined" onClick={handleCloseDeleteOpen}>
            No
          </OutlinedButton>
          <ContainedButton style={{ border: "none" }} onClick={delMarginOffer}>
            Yes
          </ContainedButton>
        </Box>
      </ModalContent>

      <ModalContent
        open={showDelete}
        onClose={handleCloseDelete}
        title={`Delete Stop-limit`}
        width="xs"
      >
        <p class="text-center">Are you sure want to delete this stop-limit?</p>
        <Box className="d-flex justify-content-center align-items-center mt-2 gap-2">
          <OutlinedButton variant="outlined" onClick={handleCloseDelete}>
            No
          </OutlinedButton>
          <ContainedButton onClick={removeStoploss}>Yes</ContainedButton>
        </Box>
      </ModalContent>

      <ModalContent
        open={showModifyStop}
        onClose={handleCloseModifyStop}
        title={`Manage Stop-limit`}
        width="xs"
      >
        <Form>
          <Form.Group>
            <Form.Label>Amount</Form.Label>
            <Form.Control
              type="number"
              value={modifySlAmount}
              className="input-active"
              onWheel={(e) => e.target.blur()}
              onChange={(e) => setModifySlAmount(e.target.value)}
              min={tradem}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Stop Price</Form.Label>
            <Form.Control
              type="number"
              value={modifySlTrigger}
              className="input-active"
              onChange={(e) => setModifySlTrigger(e.target.value)}
              onWheel={(e) => e.target.blur()}
              min={tradep}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Limit Price</Form.Label>
            <Form.Control
              type="number"
              value={modifySlPrice}
              className="input-active"
              onChange={(e) => setModifySlPrice(e.target.value)}
              onWheel={(e) => e.target.blur()}
              min={tradep}
            />
          </Form.Group>
        </Form>
        <Box className="d-flex justify-content-center align-items-center mt-2 gap-2">
          <OutlinedButton variant="outlined" onClick={handleCloseModifyStop}>
            Cancel
          </OutlinedButton>
          <ContainedButton
            style={{ border: "none" }}
            onClick={() => {
              manageStoploss();
              handleCloseModifyStop();
            }}
          >
            Submit
          </ContainedButton>
        </Box>
      </ModalContent>

      <FeeModal open={showFeesInfo} onClose={handleCloseFeesInfo} />
    </div>
  );
};

export default BottomTable;
